import React from 'react';
import { Wallet, Plus, CreditCard } from 'lucide-react';

const PaymentSettings = () => {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-bold text-foreground-primary">Payment Settings</h1>
        <p className="text-sm text-foreground-secondary mt-1">Manage your payment methods</p>
      </div>

      {/* Payment Methods */}
      <div className="glass-frosted rounded-2xl p-6 glow-subtle">
        <h2 className="text-lg font-semibold text-foreground-primary mb-4">Payment Methods</h2>
        <div className="flex flex-col items-center justify-center py-12 space-y-3">
          <Wallet size={32} className="text-foreground-muted" />
          <p className="text-sm text-foreground-muted">No payment methods added</p>
          <p className="text-xs text-foreground-muted">Add a payment method to make purchases on the Marketplace.</p>
        </div>
        <div className="flex justify-center mt-4">
          <button
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg text-sm font-semibold transition-smooth text-foreground-primary border border-subtle hover:bg-subtle"
          >
            <Plus size={16} />
            Add Payment Method
          </button>
        </div>
      </div>

      {/* Billing Address */}
      <div className="glass-frosted rounded-2xl p-6 glow-subtle">
        <h2 className="text-lg font-semibold text-foreground-primary mb-4">Billing Address</h2>
        <div className="flex flex-col items-center justify-center py-12 space-y-3">
          <CreditCard size={32} className="text-foreground-muted" />
          <p className="text-sm text-foreground-muted">No billing address set</p>
          <p className="text-xs text-foreground-muted">Required for invoice generation and tax purposes.</p>
        </div>
        <div className="flex justify-center mt-4">
          <button
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg text-sm font-semibold transition-smooth text-foreground-primary border border-subtle hover:bg-subtle"
          >
            <Plus size={16} />
            Add Billing Address
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSettings;
